import { t } from 'i18next';
import * as yup from 'yup';

export const requestDetailsSchema = () =>
  yup.object().shape({
    levelId: yup.number().label(t('labelSupportRequestLevel')).nullable(),
    statusId: yup.number().label(t('labelSupportRequestStatus')).nullable(),
    customerCompanyName: yup.string().label(t('labelCustomerCompanyName')).nullable().required(),
    requiredByDate: yup.string().label(t('labelRequestedDate')).nullable().required(),
    customerNumber: yup
      .string()
      .nullable()
      .when('customerNumberNotRequired', {
        is: false,
        then: yup
          .string()
          .label(t('labelCustomerNumber'))
          .nullable()
          .required(t('messageCustomerNumberOrProspect')),
      }),
    customerNumberNotRequired: yup.boolean().label(t('labelProspect')).nullable(),
    customerFirstName: yup.string().label(t('labelCustomerFirstName')).nullable().required(),
    customerLastName: yup.string().label(t('labelCustomerLastName')).nullable().required(),
    customerEmail: yup.string().label(t('labelCustomerEmail')).email().nullable().required(),
    type: yup.number().label(t('labelSupportRequestType')).nullable(),
  });
